import React, {
  FC, useCallback, useEffect, useRef, useState, 
} from 'react';
import { Image } from '@quarkd/quark-react';
import Danmaku from 'rc-danmaku';
import throttle, {
  downLoadApp,
  getOssImageUrl,
  getVideoCoverUrl,
} from '@/utils/utils';
import './video.less';
import { DOWNLOAD_IMG } from '@/constants/config';
import Videocz from '@/components/video';
import { ResShareData } from '@/api/appDownload';
import { indexUBT } from '@/utils/pageUbt';

interface Iprops {
  shareData: ResShareData | null;
  configData: any;
  onDownloadApp?: (options?: {
    selector?: string;
    clipboardStr?: string;
    buttonName?: string;
    includeExtraInfo?: boolean;
  }) => void;
}

const VideoC: FC<Iprops> = (props) => {
  const { configData, shareData, onDownloadApp } = props || {};
  const { barrageList = [], vedioLink = '', userCount = 0 } = shareData || {};
  const danmakuInsRef = useRef<Danmaku | null>(null);
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  
  /**
   * 处理下载App点击的辅助函数
   * 优先使用父组件传入的 onDownloadApp，否则使用原来的方式
   */
  const handleDownloadClick = useCallback((selector: string, buttonName: string) => {
    if (onDownloadApp) {
      onDownloadApp({
        selector,
        buttonName,
      });
    } else {
      downLoadApp({ selector });
      indexUBT.clickButton({
        businessInfo: {},
        buttonName,
      });
    }
  }, [onDownloadApp]);
  // eslint-disable-next-line no-bitwise
  const curindex = useRef<number>(0);
  const [listRenderAll, setListRenderAll] = useState<boolean>(false);
  const [renderData, setRenderData] = useState<any>([]);

  let timer: NodeJS.Timeout | null;
  let timer1: NodeJS.Timeout | null;

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (!listRenderAll) {
        setListRenderAll(true);
      }
    }, 300);
    const danmakuIns = new Danmaku('.danmu', {
      speed: 80, // 弹幕速度，默认100（单位px/s）
      minGapWidth: 24, // 弹幕之前的最小间隔宽度，默认值20（单位px）
    });
    danmakuInsRef.current = danmakuIns;
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (configData?.catHouseLivingData?.length) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setRenderData(
        configData.catHouseLivingData.slice(0, listRenderAll ? 20 : 4),
      );
    }
  }, [configData, listRenderAll]);

  useEffect(() => {
    const len = barrageList?.length;
    const timerPushDanmu = () => {
      if (timer) {
        clearTimeout(timer);
      }
      if (danmakuInsRef.current) {
        const item = barrageList.slice(
          curindex.current,
          curindex.current + 1,
        )[0];
        danmakuInsRef.current?.push(
          <div key={curindex.current} className="constom-danmu">
            <span
              style={{
                color: '#82E5FF',
              }}
            >
              {item.userName}
            </span>
            {item?.opeDescription || ''}
          </div>,
        );
        curindex.current = (curindex.current + 1) % len;
      }
      timer = setTimeout(() => {
        timerPushDanmu();
      }, 1000);
    };
    if (len) {
      timer = setTimeout(() => {
        timerPushDanmu();
      }, 100);
    }
  }, [danmakuInsRef.current, barrageList]);

  return (
    <>
      <div className="video-con">
        {vedioLink ? (
          <Videocz
            src={vedioLink}
            poster={'https://pet-worm.51downapp.cn/b5b4d08d_poster.jpg'}
            showCenterBtn
            showController={false}
            showBottomProgress
            pauseBtn={''}
            // isLazy={false}
            playBtn={DOWNLOAD_IMG.PAUSE_BTN}
          />
        ) : null}
      </div>
      <div className="options">
        <div
          className="input"
          id="video-input"
          onClick={() => handleDownloadClick('#video-input', 'miaowa_h5_index_shuodian_cli')}
        >
          说点什么…
        </div>
        <div className="living-btns">
          <div
            className="feed-cat"
            id="v-feed-cat"
            onClick={() => handleDownloadClick('#v-feed-cat', 'miaowa_h5_index_weimao_cli')}
          >
            <Image
              className="feed-cat-img"
              lazy={true}
              src={DOWNLOAD_IMG.FEED}
            />
            <div className="living-btn-txt">喂猫</div>
          </div>
          <div
            className="toggle-perspective"
            id="v-toggle-perspective"
            onClick={() => handleDownloadClick('#v-toggle-perspective', 'miaowa_h5_index_qiehuan_cli')}
          >
            <Image
              className="toggle-perspective-img"
              lazy={true}
              src={DOWNLOAD_IMG.PERSPECTIVE}
            />
            <div className="living-btn-txt">切换视角</div>
          </div>
          <div
            className="enter-house"
            id="v-enter-house"
            onClick={() => handleDownloadClick('#v-enter-house', 'miaowa_h5_index_jinwu_cli')}
          >
            <Image
              className="enter-house-img"
              lazy={true}
              src={DOWNLOAD_IMG.ENTER_HOUSE}
            />
            <div className="living-btn-txt">进屋</div>
          </div>
        </div>
      </div>
      <div className="total-suport">
        <div className="total-suport-txt">
          和{userCount || 0}位宝宝一起，随时随地云喂猫
        </div>
        <div
          className="total-suport-btn"
          id="v-total-suport-btn"
          onClick={() => handleDownloadClick('#v-total-suport-btn', 'miaowa_h5_index_dakaijiemao_cli')}
        >
          打开街猫App免费投喂
        </div>
      </div>
      <div className="danmu" />
      <div className="more-title">更多猫屋内容</div>
      <div ref={containerRef} className="virtual-lists">
        <div ref={wrapperRef}>
          <div className="vir-items">
            {renderData?.map((item: any, index: number) => (
              <div
                className="vir-item"
                key={index}
                id={`v-vir-item-${index}`}
                onClick={() => handleDownloadClick(`#v-vir-item-${index}`, 'miaowa_h5_index_maowu_cli')}
              >
                <Image
                  className="card-img"
                  src={getOssImageUrl(
                    String(configData?.cathouseLivingImg?.[index]),
                    170,
                    126,
                  )}
                  fit={'cover'}
                  lazy={true}
                />
                <div className="card-name">{item?.name || ''}</div>
                <div className="card-msg">
                  <div className="card-peo">
                    <Image
                      lazy={true}
                      className="card-p-img"
                      src={DOWNLOAD_IMG.LIVING_PEO}
                    />
                    <span
                      style={{
                        display: 'inline-block',
                      }}
                    >
                      {item.avgQuantity?.split('.')?.[0] || 0}人来过
                    </span>
                  </div>
                  <div className="card-feed">
                    <Image
                      lazy={true}
                      className="card-f-img"
                      src={DOWNLOAD_IMG.LIVING_FOOD}
                    />
                    <span
                      style={{
                        display: 'inline-block',
                      }}
                    >
                      {+item.feedQuantity || 0}克猫粮
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(VideoC);
